import { useEffect } from "react"
import { RootState, useAppDispatch } from "../../../../redux/store/store"
import { GetScheduleNotificationsThunk } from "../../../../redux/slices/components/ScheduleNotifications/scheduleNotificationsSlice"
import ItemsScheduleNotification from "../../../../components/ScheduleNotification/ItemsScheduleNotification/ItemsScheduleNotification"
import HeaderItemsScheduleNotification from "../../../../components/ScheduleNotification/HeaderItemsScheduleNotification/HeaderItemsScheduleNotification"
import { useSelector } from "react-redux"
import LoadingSpinner from "../../../../components/LoadingSpinner"
import HeaderButtonsScheduleNotification from "../../../../components/ScheduleNotification/HeaderButtonsScheduleNotification/HeaderButtonsScheduleNotification"


const ScheduleNotificationScreen = () => {

    const dispatch = useAppDispatch()
    const loadingContainer = useSelector((state: RootState) => state.scheduleNotificationsData.loadingContainer)

    useEffect(() => {
        
        dispatch( GetScheduleNotificationsThunk(1) )
    
        return () => {

        }
    }, [])
    

    return (
        <div className="flex flex-d-column">
            <HeaderButtonsScheduleNotification />
            <HeaderItemsScheduleNotification />
            <ItemsScheduleNotification />
            { loadingContainer ? <LoadingSpinner fullPage={true} /> : null }
        </div>
    )
}

export default ScheduleNotificationScreen